export const AUTH_BASE_PATH = '/auth';

export const AUTH_CHECK_IDENTIFIER_PATH = `${AUTH_BASE_PATH}/identifier/check`;
export const AUTH_CHECK_IDENTIFIER_FEDCM = `${AUTH_BASE_PATH}/identifier/fedcm`;
